import { Component, OnDestroy, OnInit, HostListener, ChangeDetectorRef, EventEmitter, Output, ViewChild, ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';
import { Overlay, OverlayRef, ConnectedPosition } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { CustomizerSettingsService } from '../customizer-settings/customizer-settings.service';
import { PlanificadorService, Interfaceformdata } from './control.service';
import { ApiService } from 'src/app/api.service';
import { SseService } from '../../services/SseService';
import { RastreadorService, InterfaceformdataRastreador } from '../../services/rastreador.service';
import { Subscription } from 'rxjs';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { CrearModeloComponent } from '../crear-modelo/crear-modelo.component';
import { Model } from 'src/app/models/model';
import { PlanificadorGestionComponent } from './gestion/gestion.component';
import { GraficaModeloComponent } from '../graficas/grafica-modelo/grafica-modelo.component';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogNameComponent } from '../dialog-name/dialog-name.component';
import { CookieService } from 'ngx-cookie-service';
import { DiversificadorService } from 'src/app/services/diversificador.services';
import { TemaService } from 'src/app/services/tema.services';
import { GestionService } from 'src/app/services/gestion.services';
// MatSnackBar removed; using ToastrService
import { ibrkServices } from 'src/app/services/ibrk.service';
import { Notificacion } from 'src/app/models/notificacion';
import { NotificacionService } from 'src/app/services/notificacion.service';
import { MatGridTileHeaderCssMatStyler } from '@angular/material/grid-list';
import { Location } from '@angular/common';
import { ToastrService } from "ngx-toastr";
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';
import { HelpDialogComponent, HelpDialogData } from '../common/help-dialog/help-dialog.component';
import { MAX_NOMBRE_CARTERA, nombreCarteraConSufijo } from '../../utils/nombre-cartera.util';
import { urlMercado } from '../../utils/mercado-url.util';

@Component({
    selector: 'app-models',
    templateUrl: './models.component.html',
    styleUrls: ['./models.component.scss'],
})
export class ModelsComponent implements OnInit, OnDestroy {
    public editing: boolean = false;
    existemargen: boolean = true;
    existeriesgo: boolean = true;
    //showIndice: boolean = false;
    //showVolatilidad: boolean = false;
    initfecha = '01/01/2020';
    public bajista: boolean = false;
    public ia: boolean = false;
    // true tras volcar a optimalWallet los costes que llegan por URL desde Strategy Factory.
    // Evita que cada regeneración del modelo vuelva a imponerlos sobre los cambios manuales.
    private costesUrlAplicados: boolean = false;
    public periodico: boolean = false;
    mercado: string = '';
    public condicion: any;
    public tipo: any;
    public periodoModeloPeriodico: any;
    public porcentajePrima: any;
    public msj: MessageEvent[] = [];
    Modelformdata: Interfaceformdata;
    private formdataSubcription: Subscription;
    private ModeloSub: Subscription;
    public capitalInicialIA: number = 100000;

    public valorRiesgoIA: number = 100;
    private SubTema: Subscription;
    private subOptima: Subscription;
    public ModMercat: any;
    public nombreSugerido: String = '';
    public OpeNew: any[] = [];
    selectedTab: number = 0;
    panelOpenState = false;
    public modeloMercado: any;
    public token: any;
    efectivopositivo: boolean = true;
    public indicatorsIa: string[] = [];
    allIndicatorTypes: any;
    public asignarCapital: boolean = false;
    public totalactivosmodelo: number = 0;
    public modelotemporal: any;
    public repeticionEntradas: boolean = false;
    public texto: string = ">>"
    public mouseSobreDiv: boolean = false;
    private _ignorePanelHover: boolean = false;
    private panelTimeout: any;
    public cartera: boolean = true;
    /** Modo análisis (RangeLab Option): se activa por la URL (?modo=analisis), sin persistencia. */
    public esModoAnalisis: boolean = false;
    private subQueryParams: Subscription;
    public reiniciarData: boolean = false;
    public loading: boolean = false;
    public isPlanificador: boolean = false;
    public modeloDiv: boolean = true;
    public listaCompaniaDiv: boolean = false;
    public statsFormdata: InterfaceformdataRastreador;
    public activatedEstadisticas: boolean = false;
    public diasemanaliteral: string = 'Lunes';
    public diasSemanaOptions: { nombre: string; abrev: string; valor: number }[] = [
        { nombre: 'Lunes', abrev: 'Lu', valor: 1 },
        { nombre: 'Martes', abrev: 'Ma', valor: 2 },
        { nombre: 'Miércoles', abrev: 'Mi', valor: 3 },
        { nombre: 'Jueves', abrev: 'Ju', valor: 4 },
        { nombre: 'Viernes', abrev: 'Vi', valor: 5 },
    ];
    public estadisticasPanelOpen: boolean = false;
    private subStatsFormdata: Subscription;
    private estadisticasOverlayRef: OverlayRef | null = null;
    @ViewChild('estadisticasPanel') estadisticasPanel: TemplateRef<any>;
    @ViewChild('estadisticasToggleAnchor', { read: ElementRef }) estadisticasToggleAnchor: ElementRef;
    public modelo: boolean = true;
    public isDark: boolean = false;
    public activatedModelo: boolean = false;
    public activatedOptima: boolean = false;
    public activatedInforme: boolean;
    public simularGest: boolean = false;
    //subcriptores para los botones
    public subActivateInfomr: Subscription;
    public subsimularGest: Subscription;
    public subactivatedOptima: Subscription;
    public urlCarteras = 'v1/api/portfolio/subaccounts';
    public carterasBroker: any;
    public responseData: any;
    public url = 'v1/api/iserver/auth/status';
    public todosSelected: boolean = false;

    //PRUEBAS PARA MODIFICAR EL ANCHO DE LA COLUMNA
    resizing = false;
    carteraOptima: Subscription;
    selectedTab2: number;
    /** Índice real del grupo izquierdo; única fuente de verdad (two-way con [(selectedIndex)]). */
    tabModeloIdx: number = 0;
    /** Última pestaña real (no "+") del grupo izquierdo, a la que se vuelve tras pulsar "+". */
    ultimoTabModelo: number = 0;
    theme: string;
    idnectums: number[] = [];
    @HostListener('document:mouseup') onMouseUp() {
        this.resizing = false;
    }

    @HostListener('document:focusin', ['$event']) onFocusIn(event: FocusEvent) {
        const target = event.target as HTMLElement | null;
        if (!target) return;
        const tag = target.tagName && target.tagName.toLowerCase();
        if (tag === 'input' || tag === 'textarea' || target.classList.contains('mentioning')) {
            this._ignorePanelHover = true;
        }
    }

    @HostListener('document:focusout', ['$event']) onFocusOut(event: FocusEvent) {
        const target = event.target as HTMLElement | null;
        if (!target) return;
        const tag = target.tagName && target.tagName.toLowerCase();
        if (tag === 'input' || tag === 'textarea' || target.classList.contains('mentioning')) {
            // small delay to allow focus to move between inputs without flicker
            setTimeout(() => { this._ignorePanelHover = false; }, 100);
        }
    }


    @ViewChild('rowContainer') rowContainer!: ElementRef;
    @ViewChild('column1') column1!: ElementRef;
    @ViewChild('column2') column2!: ElementRef;
    @ViewChild('column3') column3!: ElementRef;
    @ViewChild('columnLista') columnLista!: ElementRef;
    //PRUEBAS PARA MODIFICAR EL ANCHO DE LA COLUMNA

    @ViewChild(PlanificadorGestionComponent) gestionplanificador: PlanificadorGestionComponent;
    /** Instancia de la pestaña "Crear Modelo" (no la del Screener): dueña de la descarga de velas. */
    @ViewChild('crearModeloRef') crearModelo: CrearModeloComponent;
    @ViewChild(GraficaModeloComponent) graficaAnalisis: GraficaModeloComponent;
    @ViewChild('tabsModelo') tabsModelo?: MatTabGroup;

    mercados: MercadosInterface[] = [
        {
            idmercado: 0,
            iso: "",
            nombre: "Cargando mercados...",
            tipo: 0, sectype: 'STK', 
            metaapi: false
        }
    ];

    accountType: string[] = [
        'MARGEN',
        'NOMINAL'
    ]

    purchaseTypes: string[] = [
        'LIMITADO',
        'FIJO'
    ]

    frecuencySelect: SelectModelFrec[] = [];
    stopLoss: boolean = true;
    proFit: boolean = true;
    diasSalida: boolean = false;
    stopLossDinamico: boolean = true;
    public stopLossValue = 20;
    public proFitValue = 20;
    public diasSalidaValue = 0;
    public salidaFinDia: boolean = false;
    disabledByAccount: boolean = false;

    isInValid: boolean = true;
    isInValidModel: boolean = false;
    //-------------------
    public selectedFrecuency: any;
    public selectedIdMercado: any;
    public idMercadoAnt: any;
    public idMercadoIndice: number;
    public idMercadovolatilidad: number;
    public idActivoVolatilidad: number;
    public idActivoIndice: number;
    public companiasIndice: any;
    public companiasVolatilidad: any;
    public fechaInicial: any;
    public optimalWallet: OptimalWallet;
    public totalactivos: 0;
    public tempcapitalinicial: number = 0.0;
    public idmodelourl: Number;
    public idcarteraoptimaurl: number = 0;
    public fecharegistrosuscripcionurl: string = '';
    constructor(
        private toastr: ToastrService,
        private location: Location,
        public themeService: CustomizerSettingsService,
        public planificadorsv: PlanificadorService,
        private apiService: ApiService,
        private apisseservice: SseService,
        private _router: ActivatedRoute,
        public dialog: MatDialog,
        private cookieService: CookieService,
        private diversificadorsv: DiversificadorService,
        public temaservicio: TemaService,
        private cdr: ChangeDetectorRef,
        private _routerL: Router,
        private _gestionsv: GestionService,
        private _ibrkService: ibrkServices,
        private _cookieService: CookieService,
        private notificacionService: NotificacionService, private _sseservice: SseService,
        private _rastreadorservice: RastreadorService,
        private overlay: Overlay,
        private viewContainerRef: ViewContainerRef
    ) {
        this.condicion = "";
        this.tipo = ''
        this.porcentajePrima = '';
        if (!this.themeService.isHideSidebar()) {
            this.themeService.toggleHideSidebarTheme();
        }

    }
    onTabChange(event: MatTabChangeEvent): void {
        this.selectedTab = event.index;
        // La pestaña "Gráfica Análisis" puede haber recibido datos (y creado/actualizado el chart)
        // mientras estaba inactiva (contenedor "detached" del DOM, ver GraficaModeloComponent.
        // containerRef) — lightweight-charts no se autoajusta solo, así que forzamos un resize con
        // reintentos al activarla. No-op si la pestaña que quedó activa no es esta.
        this.graficaAnalisis?.scheduleEnsureCorrectSize();
    }

    // Salto desde "Analisis Periodos" a la pestaña "Gráfica Análisis". En modo análisis
    // (listaCompaniaDiv) el panel derecho solo renderiza: 0 Estadisticas · 1 Estudio Earning ·
    // 2 Gráfica Análisis.
    irAGraficaAnalisis(): void {
        this.selectedTab = this.indiceGraficaAnalisis;
        this.graficaAnalisis?.scheduleEnsureCorrectSize();
    }

    // "Gráfica Análisis" es siempre la última pestaña del panel derecho, cuyo número depende de
    // listaCompaniaDiv (Estadisticas/Earning en vez de las 5 pestañas del modelo).
    get indiceGraficaAnalisis(): number {
        return this.listaCompaniaDiv ? 2 : 5;
    }

    // Índices de las pestañas del panel de modelo (ver models.component.html). Van nombrados
    // porque este handler distingue por posición, así que insertar una pestaña desplaza el resto:
    // 0 Crear Modelo · 1 Buscador · 2 Screener · 3 "+".
    // En modo análisis la pestaña Crear Modelo no se renderiza, así que el índice real que emite
    // mat-tab-group va corrido en uno respecto de estos índices lógicos.
    private readonly TAB_SCREENER = 2;
    private readonly TAB_NUEVO_MODELO = 3;

    // Índice real de la pestaña que se abre por defecto: Screener en modo análisis, Crear Modelo si no.
    get tabModeloInicial(): number {
        return this.esModoAnalisis ? this.TAB_SCREENER - 1 : 0;
    }

    /** Vuelve el grupo izquierdo a una pestaña (p. ej. al reabrir la columna o cambiar de modo). */
    private resetTabModelo(indice: number): void {
        this.tabModeloIdx = this.ultimoTabModelo = indice;
    }

    onTab2Change(event: MatTabChangeEvent): void {
        console.log('nuevo tab ' + event.index + ' ' + this.ultimoTabModelo);
        const tabLogico = event.index + (this.esModoAnalisis ? 1 : 0);
        if (tabLogico == this.TAB_NUEVO_MODELO) {
            // "+" no es una pestaña real: volver a la anterior. Diferido y vía binding, nunca
            // escribiendo selectedIndex dentro de selectedTabChange (MatTabGroup emite antes de
            // actualizar su índice interno y la escritura re-dispara el evento en cadena).
            setTimeout(() => this.tabModeloIdx = this.ultimoTabModelo);
            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                width: '380px',
                height: '250px',
                panelClass: this.theme,
                data: {
                    msj: 'Esta Seguro de borrar todos los datos del modelo y crear otro nuevo?'
                }
            });
            dialogRef.afterClosed().subscribe(result => {
                console.log('El diálogo se cerró');
                if (result) {
                    // Mantener parámetros en la URL si existen
                    const urlParams: string[] = [];
                    if (this.idcarteraoptimaurl) {
                        urlParams.push(`idcarteraoptima=${this.idcarteraoptimaurl}`);
                    }
                    if (this.fecharegistrosuscripcionurl) {
                        urlParams.push(`fecharegistrosuscripcion=${this.fecharegistrosuscripcionurl}`);
                    }
                    if (this.esModoAnalisis) {
                        urlParams.push('modo=analisis');
                    }
                    this.location.replaceState(`/models`, urlParams.join('&'));
                    this.planificadorsv.condiciones = [];
                    this.planificadorsv.interpretacionDataListEntry = [];
                    this.planificadorsv.interpretacionDataListExit = [];
                    this.OpeNew = [];
                    this.planificadorsv.updateOperation([]);
                    this.planificadorsv.updateValoresLatente([]);
                    this.planificadorsv.updateValoresLiquidativos([]);
                    this.planificadorsv.updateopeVentas([]);
                    this.planificadorsv.updateValRentabilidad([]);
                    this.planificadorsv.updateValPos([]);
                    this.planificadorsv.updateValRiesgo([]);
                    this.planificadorsv.updateValRendAnual([]);
                    this.planificadorsv.updateactivatedOptima(false);
                }
            });
        } else {
            this.selectedTab2 = tabLogico; // app-buscador espera el índice lógico (1)
            this.ultimoTabModelo = event.index;
            // El toggle "Estadísticas" (ancla del panel flotante) vive en la pestaña Screener:
            // fuera de ella el ancla no está en el DOM y el overlay quedaría descolocado.
            if (this.esModoAnalisis) {
                if (tabLogico == this.TAB_SCREENER) {
                    setTimeout(() => this.openEstadisticasPanel());
                } else {
                    this.closeEstadisticasPanel();
                }
            }
        }


    }

    onTabLabelClick(event: MouseEvent, tabIndex: number): void {
        // Prevent default behavior to avoid triggering the tab change twice
        event.preventDefault();
        event.stopPropagation();

        console.log('ddds');
    }
    onTabButtonClick() {
        console.log('Tab action button clicked');
        // Add your button action logic here
    }
    ngOnInit() {

        this.token = this._cookieService.get('auth_token');
        this.planificadorsv.loadIndicatorTypes().then(
            (response: any) => {
                this.frecuencySelect = response.data.periodos;
                console.log("lista periodos", this.frecuencySelect);
            },
            (error) => {

            }
        );
        this.subOptima = this.planificadorsv.valoptimaWallet$.subscribe({
            next: (data: any) => {
                this.optimalWallet = data;
            }
        });

        // Estado de "Estadísticas" (Parte E): mismo formdata compartido que usa Rastreador,
        // separado de this.Modelformdata (modelo de backtest de Planificador).
        this.subStatsFormdata = this._rastreadorservice.valformdata$.subscribe({
            next: (data: any) => {
                this.statsFormdata = data;
                if (this.statsFormdata?.diaSemanaSeleccionado) {
                    const dia = this.diasSemanaOptions.find(d => d.valor === this.statsFormdata.diaSemanaSeleccionado);
                    this.diasemanaliteral = dia?.nombre ?? '';
                } else if (this.statsFormdata?.fechaInicioString) {
                    this.diasemanaliteral = this.getDiaSemanalLiteral(new Date(this.statsFormdata.fechaInicioString));
                }
            }
        });

        this.apiService.apiPost("listamercados", true, {}, 2).then((response) => {
            if (response.data) {
                this.mercados = response.data;
            }
            this.listarCompanias();
        });
        this.formdataSubcription = this.planificadorsv.getFormdata().subscribe(datos => {
            this.Modelformdata = datos;
            // El asistente puede cambiar la dirección: el selector muestra la que se va a guardar
            this.bajista = !!this.Modelformdata.bajista;
            //if (this.Modelformdata.condicion == '') {
            //  this.activatedModelo = true;
            //} else { this.activatedModelo = false; }
            this.selectedFrecuency = this.Modelformdata.period;
            console.log("Modelformdata en models: ", this.Modelformdata);
            this.selectedIdMercado = Number(this.Modelformdata.idMercado);

            let fecha = new Date(this.Modelformdata.fechaInicio);
            this.fechaInicial = this.formatDate(fecha);
        });
        /**this.planificadorsv.idMercado$.subscribe({
            next: (data: any) => {
                console.log("id mercado", data);
                this.selectedIdMercado = data;
            }
        });**/
        this.ModeloSub = this.planificadorsv.valModeloMercado$.subscribe(datos => {
            this.modeloMercado = datos;
            this.optimalWallet.idModelo = this.modeloMercado.idModelo;
            this.optimalWallet.stopLoss = this.Modelformdata.stoploss;
        });
        this.SubTema = this.temaservicio.valDarkTheme.subscribe({
            next: (data: any) => {
                this.isDark = data;
                this.theme = data ? 'dark-theme' : 'light-theme';
            }
        });
        this.carteraOptima = this.planificadorsv.isLoadCartera$.subscribe(value => {
            if (value) {
                // this.activatedOptima = value;
                console.log("valor de BOOLEAN: ", value);
            }
        });
        this.subActivateInfomr = this.planificadorsv.valactivatedInforme$.subscribe({
            next: (data: any) => {
                this.activatedInforme = data;
            }
        });
        this.subsimularGest = this.planificadorsv.valsimularGestor$.subscribe({
            next: (data: any) => {
                this.simularGest = data;
            }
        });
        this.subactivatedOptima = this.planificadorsv.valactivatedOptima$.subscribe({
            next: (data: any) => {
                this.activatedOptima = data;
            }
        });

        // recuperar id de modelo
        this.subQueryParams = this._router.queryParams.subscribe(async params => {
            let idtemp = +params['id'];
            let fecharegistrosuscripcion = params['fecharegistrosuscripcion'];
            if (fecharegistrosuscripcion) {
                this.fecharegistrosuscripcionurl = fecharegistrosuscripcion;
            }
            // Modo dirigido por la URL (sin localStorage): ?modo=analisis, con o sin id.
            const eraModoAnalisis = this.esModoAnalisis;
            this.esModoAnalisis = params['modo'] === 'analisis';
            // mat-tab-group no emite selectedTabChange en el primer render, así que la pestaña
            // por defecto (Screener en modo análisis) se registra acá para que "+" vuelva a ella.
            if (this.esModoAnalisis !== eraModoAnalisis) {
                this.resetTabModelo(this.tabModeloInicial);
                // Al aparecer/desaparecer "Crear Modelo", MatTabGroup puede conservar la pestaña
                // visible por identidad sin emitir ningún evento: alinear el modelo con lo que se ve.
                setTimeout(() => {
                    const real = this.tabsModelo?.selectedIndex;
                    if (real != null) this.resetTabModelo(real);
                });
            }
            this.listaCompaniaDiv = this.esModoAnalisis;
            this.cartera = !this.esModoAnalisis;

            if (this.esModoAnalisis) {
                this.planificadorsv.updateIdModeloActivo(0); // grafica-modelo depende de esto
                if (params['id']) {
                this._rastreadorservice.obtenerAnalisisGuardado(idtemp).subscribe({
                    next: (resp: any) => {
                        if (!resp) {
                            console.error('obtenerAnalisisGuardado devolvió una respuesta vacía (¿backend sin desplegar el endpoint nuevo?)');
                            this.toastr.error('No se pudo restaurar el análisis guardado', 'Error');
                            return;
                        }
                        this._rastreadorservice.updateIdAnalisis(idtemp);
                        this.sincronizarIdMercado(Number(resp.analisis?.idMercado));
                        this._rastreadorservice.updateArrayResultados(resp.arrayResultados);
                        this._rastreadorservice.updatelistaVariacion(resp.lva);
                        this._rastreadorservice.updatelistaVariacionNegativa(resp.lvn);
                        this._rastreadorservice.updateFormdata({
                            ...this._rastreadorservice.formdata.value,
                            condicionStr: resp.analisis?.condicion,
                            idMercado: resp.analisis?.idMercado,
                            fechaInicioString: resp.analisis?.fechaInicio,
                            diasEvaluar: resp.analisis?.diasEvaluar,
                            rangoPorcentualEvaluar: resp.analisis?.rangoPorcentualEvaluar,
                            diadesemana: resp.analisis?.diadesemana,
                            diaSemanaSeleccionado: resp.analisis?.diaSemanaSeleccionado,
                            periodoModeloPeriodico: resp.analisis?.periodoModeloPeriodico,
                            diashabiles: resp.analisis?.diasHabiles,
                        });

                        // Repuebla "Tus condiciones" y las listas de interpretación, igual que hace
                        // el flujo modelo con data.lnList/condicionln.list_conditions_entry.
                        if (resp.analisis?.lnList) {
                            try { this.planificadorsv.condiciones = JSON.parse(resp.analisis.lnList); } catch {}
                        }
                        if (resp.analisis?.condicionln) {
                            try { this.planificadorsv.interpretacionDataListEntry = JSON.parse(resp.analisis.condicionln); } catch {}
                        }
                        this.planificadorsv.interpretacionDataListExit = []; // funcionAnalisis2 ya fusiona salidas dentro de list_conditions_entry antes de persistir

                        // Puebla el formulario "Crear Modelo" (mercado/frecuencia/fecha/tipo estrategia),
                        // sin tocar stopLoss/profit/díasSalida: un análisis no tiene esos conceptos.
                        this.selectedIdMercado = Number(resp.analisis?.idMercado);
                        this.selectedFrecuency = resp.analisis?.periodo;
                        this.fechaInicial = resp.analisis?.fechaInicio;
                        this.bajista = !!resp.analisis?.bajista;
                        this.periodico = (resp.analisis?.periodoModeloPeriodico ?? 0) > 0;
                        this.Modelformdata.idMercado = resp.analisis?.idMercado;
                        this.Modelformdata.period = resp.analisis?.periodo;
                        this.Modelformdata.fechaInicio = resp.analisis?.fechaInicio;
                        this.Modelformdata.sectype = resp.analisis?.sectype;
                        this.Modelformdata.bajista = !!resp.analisis?.bajista;
                        this.Modelformdata.periodoModeloPeriodico = resp.analisis?.periodoModeloPeriodico;

                        // Abre el panel flotante "ESTADÍSTICAS" para que los parámetros restaurados
                        // (Rango %, Días, Día de semana) sean visibles sin que el usuario lo togglee a mano.
                        this.estadisticasPanelOpen = true;
                        this.openEstadisticasPanel();
                    },
                    error: (err: any) => console.error('Error al restaurar análisis guardado:', err),
                });
                }
                // sin id => layout de análisis vacío: ningún fetch
            } else if (params['id']) {
                this.idmodelourl = idtemp;
                this.planificadorsv.updateIdModeloActivo(idtemp);
                if (params['idcarteraoptima']) {
                    this.idcarteraoptimaurl = +params['idcarteraoptima'];
                    this.apisseservice.apiGetNew('parametros/' + this.idcarteraoptimaurl).subscribe({
                        next: (data: any) => {
                            if (data) {
                                console.log('Restoring optimal wallet:', data);
                                // Actualizar solo campos específicos sin reemplazar toda la cartera
                                this.optimalWallet.capitalinicial = data.capitalinicial;
                                this.optimalWallet.margen = data.margen;
                                this.optimalWallet.tipocuenta = data.tipocuenta;
                                this.optimalWallet.tiporiesgo = data.tiporiesgo;
                                this.optimalWallet.riesgomaximo = data.riesgomaximo;
                                this.optimalWallet.margenRequeridoPor = data.margenRequeridoPor;
                                this.optimalWallet.controlMarginCall = data.controlMarginCall;
                                this.optimalWallet.chkgastogest = data.chkgastogest;
                                this.optimalWallet.chkgastoprest = data.chkgastoprest;
                                this.optimalWallet.chkcomisionbroker = data.chkcomisionbroker;
                                this.optimalWallet.riesgo = data.riesgo;
                                this.planificadorsv.updateOptimaWallet(this.optimalWallet);
                            }
                        }
                    });
                }

                this.apisseservice.apiGetNew('parametrosmodelo?idmodelo=' + idtemp).subscribe({
                    next: (data: any) => {
                        //console.log(data.condicion);
                        // this.condicion = data.condicion;
                        this.planificadorsv.condiciones = JSON.parse(data.lnList);
                        const condicionln = JSON.parse(data.condicionln);
                        this.Modelformdata.idMercado = condicionln.idmercado;
                        this.Modelformdata.sectype = condicionln.sectype;
                        this.Modelformdata.bajista = condicionln.bajista;
                        this.Modelformdata.period = data.periodo;
                        this.selectedFrecuency = data.periodo;
                        this.Modelformdata.periodoModeloPeriodico = data.periodomodeloperiodico;
                        this.Modelformdata.stoploss = condicionln.stopLoss;
                        this.Modelformdata.profit = condicionln.profit;
                        this.Modelformdata.stoplossCheck = condicionln.stopLossActivo;
                        this.Modelformdata.profitCheck = condicionln.proFitActivo;
                        this.Modelformdata.stoplossDinamicCheck = condicionln.stopLossDinamicActivo;
                        this.Modelformdata.diasSalida = condicionln.diasSalida;
                        this.Modelformdata.diasSalidaCheck = condicionln.diasSalidaActivo;
                        this.stopLossValue = condicionln.stopLoss;
                        this.proFitValue = condicionln.profit;
                        this.stopLossDinamico = condicionln.stopLossDinamicActivo;
                        this.proFit = condicionln.proFitActivo;
                        this.stopLoss = condicionln.stopLossActivo;
                        this.bajista = condicionln.bajista;
                        this.diasSalida = condicionln.diasSalidaActivo;
                        this.diasSalidaValue = condicionln.diasSalida;
                        this.salidaFinDia = condicionln.salidaFinDiaActivo;
                        this.Modelformdata.salidaFinDiaCheck = this.salidaFinDia;
                        this.periodico = condicionln.periodoModeloPeriodico > 0;
                        this.Modelformdata.periodoModeloPeriodico = condicionln.periodoModeloPeriodico;
                        this.optimalWallet.prima = condicionln.periodoModeloPeriodico > 0;
                        console.log(this.optimalWallet.prima + ' prima ');
                        //this.profit = condicionln.profit;
                        this.Modelformdata.fechaInicio = condicionln.start;
                        if (fecharegistrosuscripcion) {
                            const formattedDate = fecharegistrosuscripcion.split(' ')[0];
                            console.log('Sobreescribiendo fechaInicio con fecharegistrosuscripcion formateada:', formattedDate);
                            this.Modelformdata.fechaInicio = formattedDate;
                        }
                        console.log(this.Modelformdata.idMercado);
                        this.selectedIdMercado = Number(condicionln.idmercado);
                        this.idMercadoAnt = this.selectedIdMercado;
                        this.sincronizarIdMercado(this.selectedIdMercado);
                        console.log("mercado seleccionado: ", this.selectedIdMercado);
                        this.fechaInicial = this.Modelformdata.fechaInicio;
                        this.planificadorsv.interpretacionDataListEntry = condicionln.list_conditions_entry;
                        this.planificadorsv.interpretacionDataListExit = condicionln.list_conditions_exit;
                        this.repeticionEntradas = condicionln.repeticionentradas;
                        this.planificadorsv.noCondiciones = condicionln.nocondiciones;
                        this.Modelformdata.metaapi = condicionln.metaapi;
                        //                        console.log(condicionln);
                        // Al abrir por URL nadie toca el combo de mercado/periodo, que es lo que
                        // dispara la descarga de velas: se activa aquí y el modelo se genera al terminar,
                        // para que (sobre todo en intradía) no corra con las velas de la última descarga.
                        // El mercado se arma desde condicionln porque listamercados puede no haber llegado.
                        const mercado = { idmercado: Number(condicionln.idmercado) };
                        const periodo = Number(data.periodo);
                        const generar = () => this.generateModel();
                        if (!this.crearModelo) {
                            generar();
                        } else if (condicionln.metaapi) {
                            this.crearModelo.downloadMetaapiCandles(mercado, periodo, generar);
                        } else {
                            this.crearModelo.downloadFmpIntradia(mercado, periodo, generar);
                        }
                    }
                });
            }
            if (params['ia']) {
                this.ia = true;
                console.log('IA true');
            }
        });
    }

    generateModel() {
        //        console.log("Modelo de mercado", this.Modelformdata);
        this.getModel(this.Modelformdata);
    }

    // ── Screener ────────────────────────────────────────────────────────────────────────────
    // Usa el mismo panel y el mismo motor de condiciones que "Crear Modelo", pero acotado a un
    // solo día: responde "qué compañías del mercado cumplen estas condiciones en esta fecha", y
    // con esa respuesta se puede crear una lista reutilizable como cualquier otro mercado.

    public screenerBuscando: boolean = false;
    public screenerBuscado: boolean = false;
    public screenerFechaBuscada: string = '';
    public screenerCompanias: { idNectum: number, nombreCompania: string }[] = [];
    // Mercado de la última búsqueda: el resultado sigue siendo de ese mercado aunque luego se cambie el selector.
    private screenerIdMercado: number | null = null;

    /** Abre en /mercados una compañía del resultado del screener. */
    urlMercadoScreener(c: { nombreCompania: string }): string {
        if (!this.screenerIdMercado) return '/mercados';
        const mercado = this.mercados?.find((m: any) => m.idmercado === this.screenerIdMercado) ?? { idmercado: this.screenerIdMercado };
        return urlMercado(mercado, c.nombreCompania ?? '');
    }

    buscarScreener() {
        if (this.planificadorsv.interpretacionDataListEntry.length === 0 && !this.planificadorsv.noCondiciones) {
            this.toastr.warning('Agregue al menos una condición de entrada antes de buscar', 'Screener');
            return;
        }
        const fecha = this.Modelformdata.fechaInicio;
        if (!fecha) {
            this.toastr.warning('Seleccione la fecha del estudio', 'Screener');
            return;
        }

        this.screenerBuscando = true;
        this.screenerBuscado = false;
        this.screenerCompanias = [];
        this.screenerFechaBuscada = fecha;
        this.screenerIdMercado = Number(this.selectedIdMercado) || null;

        // start = end = la fecha del estudio: sólo interesa ese día, no la serie histórica. Las
        // salidas van desactivadas porque en el screener no hay operación que cerrar (son las
        // secciones que el panel oculta en este modo).
        const jsonData = {
            list_conditions_entry: this.planificadorsv.interpretacionDataListEntry,
            list_conditions_exit: this.planificadorsv.interpretacionDataListExit,
            start: fecha,
            hora: null,
            end: fecha,
            idnectums: [],
            stopLoss: 0,
            profit: 0,
            bajista: false,
            periodo: this.Modelformdata.period,
            idmercado: this.selectedIdMercado,
            metaapi: this.Modelformdata.metaapi !== undefined ? this.Modelformdata.metaapi : this.buscarmetaapi(this.selectedIdMercado),
            sectype: this.Modelformdata.sectype,
            ln: this.planificadorsv.condiciones,
            periodoModeloPeriodico: 0,
            nocondiciones: this.planificadorsv.noCondiciones,
            repeticionentradas: false,
            stopLossActivo: false,
            stopLossDinamicActivo: false,
            proFitActivo: false,
            diasSalidaActivo: false,
            diasSalida: 0,
            salidaFinDiaActivo: false,
            licencia: this.token
        };

        const vistos = new Set<number>();
        this.apisseservice.apiGetSse('ia/crearmodelojava?data=', true, encodeURIComponent(JSON.stringify(jsonData))).subscribe({
            next: (resp: any) => {
                if (resp.name === 'licencia') {
                    this.toastr.error(resp.data);
                    return;
                }
                if (resp.name === 'modelUnsupported') {
                    this.toastr.error(this.mensajeModelUnsupported(resp.data), 'Screener', { timeOut: 10000 });
                    return;
                }
                if (resp.name !== 'ope') return;
                for (const op of resp.data) {
                    // Sólo aperturas: una compañía "cumple" cuando el motor le abre entrada ese día.
                    if (op.tipoOperacion !== 'ENTRADA') continue;
                    if (vistos.has(op.idNectum)) continue;
                    vistos.add(op.idNectum);
                    this.screenerCompanias.push({ idNectum: op.idNectum, nombreCompania: op.nombreCompania });
                }
            },
            error: () => {
                this.screenerBuscando = false;
                this.screenerBuscado = true;
                this.toastr.error('Error al buscar las compañías que cumplen las condiciones', 'Screener');
            },
            complete: () => {
                this.screenerBuscando = false;
                this.screenerBuscado = true;
                this.screenerCompanias.sort((a, b) => a.nombreCompania.localeCompare(b.nombreCompania));
            }
        });
    }

    // Payload de modelUnsupported: { message, condition, ... } (o texto plano si no era JSON)
    private mensajeModelUnsupported(data: any): string {
        if (!data || typeof data === 'string') return data || 'Una condición no se puede evaluar';
        const condicion = data.condition ? ` — ${String(data.condition).replace(/^DSL:/, '')}` : '';
        return `${data.message || 'Una condición no se puede evaluar'}${condicion}`;
    }

    crearListaScreener() {
        if (this.screenerCompanias.length === 0) return;

        const dialogRef = this.dialog.open(DialogNameComponent, {
            width: '380px',
            panelClass: this.theme,
            data: { name: '', titulo: 'Nombre de la lista' }
        });

        dialogRef.afterClosed().subscribe((nombre: string) => {
            if (!nombre || !nombre.trim()) return;
            const nombreLista = nombre.trim();

            // Mismo flujo que gestion-listas/lista-compania: crearlista devuelve el mercado creado
            // (idmercado 0 si el nombre ya existe) y después se le cuelgan las compañías.
            const jsondata = {
                nombre: nombreLista,
                iso: nombreLista,
                metaapi: this.buscarmetaapi(this.selectedIdMercado),
                sectype: this.Modelformdata.sectype || 'STK'
            };
            this.apisseservice.apiPostNew('crearlista', jsondata, this.token).subscribe({
                next: (lista: any) => {
                    if (!lista || !(lista.idmercado > 0)) {
                        this.toastr.error('El nombre de la lista ya existe', 'Screener');
                        return;
                    }
                    const companias = this.screenerCompanias.map(c => ({
                        idmercado: lista.idmercado,
                        idnectum: c.idNectum
                    }));
                    this.apisseservice.apiPostNew('agregarcompanialista', companias, this.token).subscribe({
                        next: (resp: any) => {
                            if (resp && resp.estatus) {
                                this.toastr.success(`Lista "${nombreLista}" creada con ${companias.length} compañía(s)`, 'Screener');
                            } else {
                                this.toastr.error('No se pudieron agregar las compañías a la lista', 'Screener');
                            }
                        },
                        error: () => this.toastr.error('No se pudieron agregar las compañías a la lista', 'Screener')
                    });
                },
                error: () => this.toastr.error('No se pudo crear la lista', 'Screener')
            });
        });
    }


    async getModel(data: any) {
        console.log(this.periodico);
        console.log(this.periodoModeloPeriodico);
        console.log(this.planificadorsv.interpretacionDataListEntry);
        console.log(this.planificadorsv.interpretacionDataListExit);
        console.log(this.planificadorsv.noCondiciones);
        if (this.planificadorsv.interpretacionDataListEntry.length > 0 || this.planificadorsv.interpretacionDataListExit.length > 0 || this.planificadorsv.noCondiciones || this.periodico) {
            this.loading = true;
            let ope: any[] = [];
            let activossmodelo: String[] = [];
            this.planificadorsv.updateaisshoW(false);
            console.log("se reiniciaran los datos");
            let primatemp = this.optimalWallet.prima;
            this.inicializarDataPlanificador();
            this.inicializarDatosia();
            this.optimalWallet.prima = primatemp;
            this.planificadorsv.updateCarteraoptima();
            //this.planificadorsv.updateExecuteGrap(false);
            this.activatedModelo = true;
            let jsonData = {
                list_conditions_entry: this.planificadorsv.interpretacionDataListEntry,
                list_conditions_exit: this.planificadorsv.interpretacionDataListExit,
                start: this.Modelformdata.fechaInicio,
                hora: this.fecharegistrosuscripcionurl ? (this.fecharegistrosuscripcionurl.split(' ')[1] || null) : null,
                end: new Date().toISOString().split('T')[0],
                idnectums: [],
                stopLoss: this.Modelformdata.stoploss || this.stopLossValue,
                profit: this.Modelformdata.profit || this.proFitValue,  // Add fallback to proFitValue
                bajista: this.Modelformdata.bajista,
                periodo: this.Modelformdata.period,
                idmercado: this.selectedIdMercado,
                metaapi: this.Modelformdata.metaapi !== undefined ? this.Modelformdata.metaapi : this.buscarmetaapi(this.selectedIdMercado),
                sectype: this.Modelformdata.sectype,
                ln: this.planificadorsv.condiciones,
                periodoModeloPeriodico: this.Modelformdata.periodoModeloPeriodico,
                nocondiciones: this.planificadorsv.noCondiciones,
                repeticionentradas: this.repeticionEntradas,
                stopLossActivo: this.stopLoss,
                stopLossDinamicActivo: this.stopLossDinamico,
                proFitActivo: this.proFit,
                diasSalidaActivo: this.diasSalida,
                diasSalida: this.Modelformdata.diasSalida || this.diasSalidaValue,
                salidaFinDiaActivo: this.salidaFinDia,
                licencia: this.token
            };
            console.log("JSON DATA ", jsonData);
            this.totalactivosmodelo = 0;
            this.modelotemporal = null;
            let estadomostrado = false;
            this.apisseservice.apiGetSse('ia/crearmodelojava?data=', true, encodeURIComponent(JSON.stringify(jsonData))).subscribe(
                {
                    next: (resp: any) => {
                        //console.log('nombre ' + resp.name);
                        if (resp.name === 'mod') {
                            this.modelotemporal = resp.data;
                        }
                        if (resp.name === 'licencia') {
                            this.toastr.error(resp.data);
                        }
                        if (resp.name === 'analysisSummary') {
                            //resp.data es = {"operationsGenerated":3891,"modelId":913077,"assetsAnalyzed":96,"event":"analysisSummary","timestamp":1762195056603}	
                            this.toastr.success(`Análisis completado: ${resp.data.operationsGenerated} operaciones generadas en ${resp.data.assetsAnalyzed} activos analizados.`);
                        }
                        if (resp.name === 'ope') {
                            ope.push(resp.data);
                            // console.log(resp.data.length);
                            if (this.asignarCapital) {
                                for (let i = 0; i < resp.data.length; i++) {

                                    if (!activossmodelo.includes(resp.data[i].nombreCompania)) {
                                        activossmodelo.push(resp.data[i].nombreCompania);
                                    }
                                }
                                this.asignarCapitalFuncion(activossmodelo.length);
                            }
                            this.totalactivosmodelo = this.totalactivosmodelo + resp.data.length;
                            if (this.totalactivosmodelo > 0 && this.modelotemporal != null && !estadomostrado) {
                                this.ModMercat = this.modelotemporal;
                                this.idmodelourl = this.modelotemporal.idModelo;
                                this.planificadorsv.updateIdModeloActivo(this.idmodelourl as number);
                                // Si no se tocó el combo, el mercado por defecto nunca llegó a la gráfica embebida.
                                if (this.planificadorsv.idMercado !== this.selectedIdMercado) {
                                    this.sincronizarIdMercado(this.selectedIdMercado);
                                }
                                this.location.replaceState(`/models`, `id=${this.idmodelourl}`);
                                // ...dentro del bloque donde haces el replaceState...
                                const queryParams: string[] = [`id=${this.idmodelourl}`];
                                const iaParam = this._router.snapshot.queryParamMap.get('ia');
                                if (iaParam === 'true') {
                                    queryParams.push('ia=true');
                                    const capitalInicialParam = this._router.snapshot.queryParamMap.get('capitalinicial');
                                    const valorRiesgoParam = this._router.snapshot.queryParamMap.get('valorriesgo');
                                    const tiporiesgoParam = this._router.snapshot.queryParamMap.get('tiporiesgo');
                                    const fraccionesParam = this._router.snapshot.queryParamMap.get('fracciones');
                                    if (capitalInicialParam) {
                                        this.capitalInicialIA = Number(capitalInicialParam);
                                        queryParams.push(`capitalinicial=${capitalInicialParam}`);
                                        this.optimalWallet.capitalinicial = this.capitalInicialIA;
                                    }
                                    if (valorRiesgoParam) {
                                        this.valorRiesgoIA = Number(valorRiesgoParam);
                                        this.optimalWallet.riesgo = this.valorRiesgoIA;
                                        queryParams.push(`valorriesgo=${valorRiesgoParam}`);
                                    }
                                    if (tiporiesgoParam) {
                                        this.optimalWallet.tiporiesgo = tiporiesgoParam;
                                        queryParams.push(`tiporiesgo=${tiporiesgoParam}`);
                                    }
                                    if (fraccionesParam) {
                                        this.optimalWallet.participacion = fraccionesParam === 'true';
                                        queryParams.push(`fracciones=${fraccionesParam}`);
                                    }
                                    // Leer los 4 nuevos parámetros de la URL
                                    const tipoCuentaParam = this._router.snapshot.queryParamMap.get('tipoCuenta');
                                    const margenRequeridoParam = this._router.snapshot.queryParamMap.get('margenRequeridoPor');
                                    const controlMarginCallParam = this._router.snapshot.queryParamMap.get('controlMarginCall');
                                    const riesgoMaximoParam = this._router.snapshot.queryParamMap.get('riesgoMaximo');

                                    if (tipoCuentaParam) {
                                        this.optimalWallet.tipocuenta = tipoCuentaParam;
                                        queryParams.push(`tipoCuenta=${tipoCuentaParam}`);
                                    }
                                    if (margenRequeridoParam) {
                                        this.optimalWallet.margenRequeridoPor = Number(margenRequeridoParam);
                                        queryParams.push(`margenRequeridoPor=${margenRequeridoParam}`);
                                    }
                                    if (controlMarginCallParam) {
                                        this.optimalWallet.controlMarginCall = Number(controlMarginCallParam);
                                        queryParams.push(`controlMarginCall=${controlMarginCallParam}`);
                                    }
                                    if (riesgoMaximoParam) {
                                        this.optimalWallet.riesgomaximo = Number(riesgoMaximoParam);
                                        queryParams.push(`riesgoMaximo=${riesgoMaximoParam}`);
                                    }

                                    // Comisión y gastos con los que se simuló en Strategy Factory.
                                    // Se comparan contra null/'' y no por truthy, porque un 0 es un
                                    // valor legítimo (coste desactivado) que no debe perderse.
                                    const comisionBrokerParam = this._router.snapshot.queryParamMap.get('comisionbroker');
                                    const gastosGestionParam = this._router.snapshot.queryParamMap.get('gastosGestionPor');
                                    const gastosPrestamoParam = this._router.snapshot.queryParamMap.get('gastosPrestamoPor');

                                    const chkComisionParam = this._router.snapshot.queryParamMap.get('chkcomisionbroker');
                                    const chkGastoGestParam = this._router.snapshot.queryParamMap.get('chkgastogest');
                                    const chkGastoPrestParam = this._router.snapshot.queryParamMap.get('chkgastoprest');

                                    // Este bloque se ejecuta en CADA getModel y el snapshot de la ruta no
                                    // cambia nunca, así que sin este guard cada regeneración volvería a
                                    // imponer los costes de la URL y pisaría los cambios hechos a mano.
                                    // Los push a queryParams se hacen siempre, para que la URL reconstruida
                                    // conserve los costes y recargar la página los vuelva a aplicar.
                                    const aplicarCostes = !this.costesUrlAplicados;

                                    if (comisionBrokerParam !== null && comisionBrokerParam !== '') {
                                        if (aplicarCostes) this.optimalWallet.comisionbroker = Number(comisionBrokerParam);
                                        queryParams.push(`comisionbroker=${comisionBrokerParam}`);
                                    }
                                    if (gastosGestionParam !== null && gastosGestionParam !== '') {
                                        if (aplicarCostes) this.optimalWallet.gastosGestionPor = Number(gastosGestionParam);
                                        queryParams.push(`gastosGestionPor=${gastosGestionParam}`);
                                    }
                                    if (gastosPrestamoParam !== null && gastosPrestamoParam !== '') {
                                        if (aplicarCostes) this.optimalWallet.gastosPrestamoPor = Number(gastosPrestamoParam);
                                        queryParams.push(`gastosPrestamoPor=${gastosPrestamoParam}`);
                                    }
                                    if (chkComisionParam !== null && chkComisionParam !== '') {
                                        if (aplicarCostes) this.optimalWallet.chkcomisionbroker = chkComisionParam === 'true';
                                        queryParams.push(`chkcomisionbroker=${chkComisionParam}`);
                                    }
                                    if (chkGastoGestParam !== null && chkGastoGestParam !== '') {
                                        if (aplicarCostes) this.optimalWallet.chkgastogest = chkGastoGestParam === 'true';
                                        queryParams.push(`chkgastogest=${chkGastoGestParam}`);
                                    }
                                    if (chkGastoPrestParam !== null && chkGastoPrestParam !== '') {
                                        if (aplicarCostes) this.optimalWallet.chkgastoprest = chkGastoPrestParam === 'true';
                                        queryParams.push(`chkgastoprest=${chkGastoPrestParam}`);
                                    }
                                    this.costesUrlAplicados = true;
                                    console.log("parametros ia en url" + iaParam);

                                }
                                // Mantener parámetros adicionales si existen
                                if (this.idcarteraoptimaurl) {
                                    queryParams.push(`idcarteraoptima=${this.idcarteraoptimaurl}`);
                                }
                                if (this.fecharegistrosuscripcionurl) {
                                    queryParams.push(`fecharegistrosuscripcion=${this.fecharegistrosuscripcionurl}`);
                                }
                                this.location.replaceState(`/models`, queryParams.join('&'));

                                this.toastr.success("Modelo generado");
                                estadomostrado = true;
                            }
                            this.planificadorsv.updateOperation(ope);
                        }
                        if (resp.name === 'nom') {
                            console.log(resp);
                            this.nombreSugerido = resp.data;
                            console.log(this.nombreSugerido);
                        }
                        if (resp.name === 'err') {
                            this.toastr.error(resp.data);
                        }
                        if (resp.name === 'modelUnsupported') {
                            this.toastr.error(this.mensajeModelUnsupported(resp.data), 'Condición no soportada', { timeOut: 10000 });
                        }
                    }, error(err) {
                        console.log("hubo un error");
                    }, complete: () => {
                        this.planificadorsv.updateMod(this.ModMercat);
                        this.activatedModelo = false;
                        //                    console.log("LONGITUD DE OPERACIONES ", this.validarVacio(ope));
                        if (this.validarVacio(ope)) {
                            console.log("esta vacio las operaciones")
                            this.planificadorsv.updateactivatedOptima(false);
                        } else {
                            this.planificadorsv.updateactivatedOptima(true);
                            console.log("hayData");
                        }
                        this.OpeNew = [];
                        this.loading = false;
                        if (this.modelo) {
                            this.planificadorsv.updateCarteraoptima();
                        }
                        console.log("this loading deberia cerrar spinner", this.loading);
                        console.log("Reinicia data: ", this.reiniciarData);
                        this.cdr.detectChanges();
                    }
                });
        } else {
            this.toastr.error("Se deben introducir condiciones para crear un modelo");
        }
    }
    inicializarDatosia() {
        console.log('inicializar datos ia');
        if (this.ia) {
            this.optimalWallet.capitalinicial = this.capitalInicialIA;
            //if(this.capitalInicialIA && this.valorRiesgoIA){
            //  this.optimalWallet.capitalinicial = this.capitalInicialIA;
            //this.optimalWallet.riesgomaximo = this.valorRiesgoIA;
            //}
            //this.optimalWallet.riesgomaximo = 100;
            //this.optimalWallet.margenRequeridoPor = 1;
            //this.optimalWallet.controlMarginCall = 100;
            // Antes se forzaban aquí comisión y gastos a 0/false porque Strategy Factory no
            // cobraba costes y era la única forma de que ambas pantallas cuadrasen. Ahora el
            // backtest sí los aplica y llegan por la URL, así que ponerlos a cero rompería la
            // equivalencia en vez de conseguirla.
        }
    }

    validarVacio(arr: any[]): boolean {
        return arr.every(subArray => Array.isArray(subArray) && subArray.length === 0);
    }
    asignarCapitalFuncion(activosdistintos: number) {
        console.log(this.totalactivosmodelo);
        console.log(activosdistintos);
        let capitalInicialPrima = (this.optimalWallet.capitales[0] * activosdistintos) + (this.optimalWallet.capitales[1] * (this.totalactivosmodelo - activosdistintos));
        console.log(capitalInicialPrima);
        this.optimalWallet.capitalinicial = capitalInicialPrima;
    }
    getOptimalWallet(data: any, planificador: boolean, diversificador: boolean) {
        let liqval: any[] = [];
        let ventOp: any[] = [];
        let vla: any[] = [];
        let rentabilida: any[] = [];
        let riesgo: any[] = [];
        let rendimiendoAnual: any[] = [];
        let pos: any[] = [];
        let ope: any[] = [];
        this.existemargen = true;
        this.existeriesgo = true;
        this.efectivopositivo = true;
        let primatemp = this.optimalWallet.prima;
        this.inicializarDataPlanificador();
        this.optimalWallet.prima = primatemp;
        this.planificadorsv.updateactivatedOptima(false);
        this.activatedModelo = !this.activatedModelo;
        this.loading = true;
        // let activos: String [] = [];
        data.metaapi = this.buscarmetaapi(this.selectedIdMercado);
        // Un coste con su toggle apagado se envía a 0, así la comisión no se cobra aunque se vea apagada.
        // Los chk se normalizan a booleano: si llegan undefined se serializan como "undefined" y
        // Spring responde 400 al no poder convertirlo a Boolean.
        // Se hace sobre una copia para no perder el importe que el usuario tiene configurado.
        const payload = {
            ...data,
            chkcomisionbroker: !!data.chkcomisionbroker,
            chkgastogest: !!data.chkgastogest,
            chkgastoprest: !!data.chkgastoprest,
            comisionbroker: data.chkcomisionbroker ? data.comisionbroker : 0,
            gastosGestionPor: data.chkgastogest ? data.gastosGestionPor : 0,
            gastosPrestamoPor: data.chkgastoprest ? data.gastosPrestamoPor : 0,
        };
        this.apisseservice.apiGetSse('Recalcular?', true, payload).subscribe({
            next: (resp: any) => {
                //console.log(resp.name);
                if (resp.name === 'ico') {
                    console.log(' data ' + data);
                    this.idcarteraoptimaurl = resp.data;
                    this.location.replaceState(`/models`, `id=${this.optimalWallet.idModelo}&idcarteraoptima=${this.idcarteraoptimaurl}`);
                }
                if (resp.name === 'ope') {
                    ope.push(resp.data);
                    if (planificador) {
                        this.planificadorsv.updateOperation(ope);
                    } else if (diversificador) {
                        //     console.log("Operaciones Diversificador",ope);
                        this.diversificadorsv.updateDivOpe(ope);
                    }
                    var temp = resp.data[resp.data.length - 1];
                    this.optimalWallet.margen = (temp.margentotal).toFixed(2);
                    this.optimalWallet.fondosDisponibles = (temp.fondosdisponibles).toFixed(2);
                    this.optimalWallet.poderCompra = (temp.podercompra).toFixed(2);
                    this.optimalWallet.efectivo = (temp.efectivo).toFixed(2);
                    this.optimalWallet.valorLiquidativo = (temp.valorliquidativo).toFixed(2);
                    this.efectivopositivo = this.optimalWallet.efectivo > 0;

                } else if (resp.name === 'vla') {
                    vla.push(resp.data);
                    if (planificador) {
                        this.planificadorsv.updateValoresLatente(vla);
                    } else if (diversificador) {
                        //    console.log("Valores Latentes Divsersificador",vla);
                        this.diversificadorsv.updateDivLate(vla);
                    }
                } else if (resp.name === 'vli') {
                    liqval.push(resp.data);
                    //nsole.log(resp.data);
                    if (planificador) {
                        this.planificadorsv.updateValoresLiquidativos(liqval);
                    } else if (diversificador) {
                        //   console.log("Valores Liq Divsersificador",liqval);
                        this.diversificadorsv.updateDivLiq(liqval);
                    }
                } else if (resp.name === 'pos') {

                    pos.push(resp.data);
                    if (planificador) {
                        this.planificadorsv.updateValPos(pos);
                    } else if (diversificador) {
                        //     console.log("POS Divsersificador",pos);
                        this.diversificadorsv.updateDivPos(pos);
                    }
                }
                else if (resp.name === 'ven') {
                    ventOp.push(resp.data);
                    if (planificador) {
                        this.planificadorsv.updateopeVentas(ventOp);
                    } else if (diversificador) {
                        //   console.log("VENT Divsersificador",ventOp);
                        this.diversificadorsv.updateDivVentas(ventOp);
                    }
                } else if (resp.name === 'ren') {
                    rentabilida.push(resp.data);
                    if (planificador) {
                        this.planificadorsv.updateValRentabilidad(rentabilida);
                    } else if (diversificador) {
                        //    console.log("Rentabilidad Divsersificador",rentabilida);
                        this.diversificadorsv.updateDivRent(rentabilida);
                    }
                } else if (resp.name === 'rie') {
                    riesgo.push(resp.data);
                    if (planificador) {
                        this.planificadorsv.updateValRiesgo(riesgo);
                    } else if (diversificador) {
                        //  console.log("rie Divsersificador",resp.data);
                        this.diversificadorsv.updateDivRiesgo(riesgo)
                    }
                } else if (resp.name === 'rea') {
                    rendimiendoAnual.push(resp.data);
                    if (planificador) {
                        this.planificadorsv.updateValRendAnual(rendimiendoAnual);
                    } else if (diversificador) {
                        // console.log("rea Divsersificador",resp.data);
                        this.diversificadorsv.updateDivRendAnual(rendimiendoAnual);
                    }
                } else if (resp.name === 'err') {
                    let errorstring = resp.data;
                    let titulo = '';
                    if (errorstring.includes('han superado los Requerimientos de Margen')) {
                        this.existemargen = false;
                        titulo = 'Control Margin Call %';
                    }
                    if (errorstring.includes('Se ha superado los Requerimientos de Margen para su carter')) {
                        this.existemargen = false;
                        titulo = 'Control Margin Call %';
                    }
                    if (errorstring.includes('e ha superado el riesgo máximo establecido')) {
                        this.existeriesgo = false;
                        titulo = 'Riesgo Maximo';
                    }
                    if (errorstring.includes('e ha superado el riesgo para una nueva operacion')) {
                        this.existeriesgo = false;
                        titulo = 'Riesgo para Nueva Operacion';
                    }
                    if (errorstring.includes('')) {
                        this.existemargen = false;
                        titulo = 'Margen Superado';
                    }
                    //console.log(resp.data);
                    this.toastr.error(resp.data, titulo, {
                        timeOut: 30000,
                        positionClass: 'toast-top-center',
                        enableHtml: true
                    });
                    this.guardarNotificacion(new Notificacion(titulo, errorstring, 'PLANIFICAOOR'));
                }
            }, error(err) {
                console.log("hubo un error")
            }, complete: () => {
                this.planificadorsv.updateaisshoW(true);
                console.log("se COMPLETO el envio de datos. ");
                this.loading = false;
                console.log("this loading deberia cerrar spinner", this.loading);
                this.OpeNew = [];
                // this.activatedOptima = true;
                this.planificadorsv.updateactivatedOptima(true);
                this.planificadorsv.updatesimularGestor(true);
                this.activatedModelo = !this.activatedModelo;
                this.planificadorsv.updateactivatedInforme(true);
                this.planificadorsv.updateOptimaWallet(this.optimalWallet);
                this.planificadorsv.updateExecuteGrap(true);
                this.cdr.detectChanges();
            }
        });
    }

    inicializarDataPlanificador() {
        this.planificadorsv.updateOperation([]);
        this.planificadorsv.updateValoresLatente([]);
        this.planificadorsv.updateValoresLiquidativos([]);
        this.planificadorsv.updateValPos([]);
        this.planificadorsv.updateopeVentas([]);
        this.planificadorsv.updateValRentabilidad([]);
        this.planificadorsv.updateValRiesgo([]);
        this.planificadorsv.updateValRendAnual([]);
        this.planificadorsv.updateactivatedInforme(false);
        this.planificadorsv.updatesimularGestor(false);
//        this.optimalWallet = this.planificadorsv.getDefaultOptima();
    }
    onTodosChange(event: any) {
        if (event.checked) {
            let diasHabiles = this.calcularDiasHabiles(this.Modelformdata.fechaInicio);
            if (diasHabiles < 1500) {
                this.Modelformdata.periodoModeloPeriodico = diasHabiles;
            } else {
                this.todosSelected = false;
                this.toastr.error('La fecha inicial debe ser desde 2020');
            }
        } else {
            this.Modelformdata.periodoModeloPeriodico = 0; // o cualquier valor por defecto
        }
        this.changeInput('periodoModeloPeriodico', { target: { value: this.Modelformdata.periodoModeloPeriodico } });
    }
    calcularDiasHabiles(fechaInicio: string): number {
        const inicio = new Date(fechaInicio);
        const hoy = new Date();
        let diasHabiles = 0;

        for (let d = inicio; d <= hoy; d.setDate(d.getDate() + 1)) {
            if (d.getDay() !== 0 && d.getDay() !== 6) { // 0 es domingo, 6 es sábado
                diasHabiles++;
            }
        }

        return diasHabiles;
    }
    calcularData() {
        console.log("entro a calcular");

        // Actualizar capitalInicialIA cuando se cambia manualmente el capital inicial
        // Solo si el apalancamiento es 1 (sin apalancamiento)
        if (this.optimalWallet.apalancamiento === 1) {
            this.capitalInicialIA = this.optimalWallet.capitalinicial;
        }

        this.optimalWallet.capitales[1] = this.optimalWallet.riesgo;
        this.optimalWallet.efectivo = this.optimalWallet.capitalinicial;
        this.optimalWallet.valorLiquidativo = this.optimalWallet.capitalinicial;
        this.optimalWallet.fondosDisponibles = this.optimalWallet.capitalinicial;
        this.optimalWallet.poderCompra = this.optimalWallet.capitalinicial;//this.optimalWallet.capitalinicial * this.optimalWallet.apalancamiento;
        this.optimalWallet.margen = 0;
    }
    calcularDataApalancamiento() {
        // Usar el capitalInicialIA como base para calcular con apalancamiento
        this.optimalWallet.capitalinicial = this.capitalInicialIA * this.optimalWallet.apalancamiento;
        this.calcularData();
    }
    buscarCompania(tipo: string) {

        if (tipo == 'Indice') {
            const jsonData = {
                idmercado: this.idMercadoIndice
            };
            this.apisseservice.apiPostNew('listadecompaniaspormercado', jsonData, this.token).subscribe({
                next: (data: any) => {
                    this.companiasIndice = data;
                }
            });
        } else if (tipo == 'Volatilidad') {
            const jsonData = {
                idmercado: this.idMercadovolatilidad
            };
            this.apisseservice.apiPostNew('listadecompaniaspormercado', jsonData, this.token).subscribe({
                next: (data: any) => {
                    this.companiasVolatilidad = data;
                }
            });
        }

    }
    registrarCompania(input: string, event: any) {
        console.log("registrar" + this.idActivoIndice);
        console.log(event);
        if (input == 'IndiceActivo') {
            this.planificadorsv.idActivoIndice = this.idActivoIndice;
            console.log(this.planificadorsv.idActivoIndice);
        }
        if (input == 'VolatilidadActivo') {
            console.log(this.planificadorsv.idActivoVolatilidad);
            this.planificadorsv.idActivoVolatilidad = this.idActivoVolatilidad;
        }
    }
    changeInput(input: string, event: any) {
        var ainput = event.target?.value || event?.value || event?.checked;
        console.log(input);
        console.log(ainput);
        if (input === "fechaInicio") {
            let obfecha = new Date(ainput);
            let dia = obfecha.getDate();
            let mes = obfecha.getMonth() + 1;
            let year = obfecha.getFullYear();
            ainput = `${year}-${mes.toString().padStart(2, '0')}-${dia.toString().padStart(2, '0')}`;
            this.Modelformdata.fechaInicio = ainput;
            this.fecharegistrosuscripcionurl = '';
        } else if (input === 'periodosucesivo') {
            this.optimalWallet.riesgo = this.optimalWallet.capitales[1];
            this.actualizarcapitalinicial();
        } else if (input === 'periodos') {
            this.actualizarcapitalinicial();
        } else if (input === 'periodoModeloPeriodico') {
            const parsedPeriodo = Number(ainput);
            this.Modelformdata.periodoModeloPeriodico = Number.isNaN(parsedPeriodo) ? 0 : parsedPeriodo;
            this.actualizarcapitalinicial();
        } else if (input === 'asignarCapital') {
            console.log('asignarCapital ' + this.asignarCapital);
        } else if (input === 'repeticionEntradas') {
            this.repeticionEntradas = !!ainput;
        } else if (input === 'periodico') {
            console.log(event);
            console.log(input);
            this.periodico = !!ainput;
            if (event.checked) {
                this.Modelformdata.periodoModeloPeriodico = 0;

                this._sseservice.apiPostNew('mercado/contarActivosporMercado', { idmercado: this.Modelformdata.idMercado }, '').toPromise().then(
                    response => {
                        this.totalactivos = response.total;
                        if (this.totalactivos <= 10) {
                            this.actualizarcapitalinicial();
                            this.optimalWallet.riesgo = this.optimalWallet.capitales[1];
                            this.optimalWallet.riesgomaximo = 100;
                            this.optimalWallet.tipocuenta = 'NOMINAL';
                        } else {
                            this.toastr.error("La lista de mercados seleccionada puede tener un máximo de 10 activos.");
                            //revert event and unchek
                            this.periodico = false;
                            this.optimalWallet.prima = false;
                            this.optimalWallet.riesgomaximo = 50;
                            this.optimalWallet.tipocuenta = 'MARGEN';
                        }
                    }
                ).catch(error => {
                    // this.loading = false;
                });
            } else {
                this.periodico = false;
                this.Modelformdata.periodoModeloPeriodico = -1;

                this.optimalWallet.capitalinicial = 100000;
                this.optimalWallet.prima = false;
                this.optimalWallet.riesgomaximo = 50;
                console.log('changeinput');
                this.optimalWallet.tipocuenta = 'MARGEN';
                this.planificadorsv.noCondiciones = false;
            }

        }
        else if (input === 'idMercado') {
            // app-mercado-select emite { value: idmercado } (antes era un <select> con "n: id").
            this.selectedIdMercado = Number(event?.value ?? event?.target?.value);
            console.log(this.selectedIdMercado);
            this.Modelformdata.idMercado = this.selectedIdMercado;
            this.sincronizarIdMercado(this.selectedIdMercado);
            console.log(this.Modelformdata.idMercado + ' ' + this.buscarsectype(this.Modelformdata.idMercado));
            this.Modelformdata.sectype = this.buscarsectype(this.Modelformdata.idMercado);
            const mercadoSeleccionado = this.mercados.find(m => m.idmercado === Number(this.selectedIdMercado));
            if (mercadoSeleccionado) {
               // this.Modelformdata.margen = mercadoSeleccionado.metaapi ? 1 : 30;
                this.optimalWallet.margenRequeridoPor = mercadoSeleccionado.metaapi ? 1 : 30;
                // Si no, getModel() arrastra el metaapi del modelo cargado por URL.
                this.Modelformdata.metaapi = mercadoSeleccionado.metaapi;
            }
            //this.listarCompanias();
            if (this.periodico) {
                this._sseservice.apiPostNew('mercado/contarActivosporMercado', { idmercado: this.Modelformdata.idMercado }, '').toPromise().then(
                    response => {
                        this.totalactivos = response.total;

                        if (this.totalactivos <= 10) {

                            this.actualizarcapitalinicial();
                        } else {
                            this.toastr.error("La lista de mercados seleccionada puede tener un máximo de 10 activos.");
                            this.Modelformdata.idMercado = this.idMercadoAnt;
                            this.selectedIdMercado = this.idMercadoAnt;
                            this.sincronizarIdMercado(Number(this.idMercadoAnt));
                        }
                    }
                ).catch(error => {
                    // this.loading = false;
                });
            } else
                this.idMercadoAnt = this.selectedIdMercado;
        }
        else if (input === 'period') {
            this.Modelformdata.period = event;
            this.selectedFrecuency = event;
        } else if (input === 'stoploss') {
            this.Modelformdata.stoploss = ainput;
        } else if (input === 'profit') {
            this.Modelformdata.profit = ainput;
        } else if (input === 'diasSalida') {
            this.Modelformdata.diasSalida = ainput;
        }
        this.planificadorsv.updateFormdata(this.Modelformdata);
    }
    /** Propaga el mercado activo de Models a los servicios que lee la gráfica embebida (y el screener). */
    private sincronizarIdMercado(idMercado: number): void {
        if (!(idMercado > 0)) return;
        this.planificadorsv.updateIdMercado(idMercado);
        this._rastreadorservice.updateIdMercado(idMercado);
    }

    listarCompanias() {
        const jsonData = {
            idmercado: this.selectedIdMercado
        };
        this.idnectums = [];
        this.apisseservice.apiPostNew('listadecompaniaspormercado', jsonData, this.token).subscribe({
            next: (data: any) => {
                //              console.log(data);
                data.forEach((item: any) => {
                    this.idnectums.push(item.idNectum);
                });
            }
        });
    }

    disabledMargin(event: any) {
        //console.log(event.target.value);
        if (this.optimalWallet.tipocuenta == 'MARGEN') {
            this.optimalWallet.poderCompra = 100000
            this.disabledByAccount = false;
        }
        else {
            this.optimalWallet.poderCompra = 100000
            this.disabledByAccount = true;
        }
    }

    walletAnalysis() {
        console.log(this.optimalWallet);
        this.optimalWallet.idModelo = this.modeloMercado.idModelo;
        console.log(this.optimalWallet);
        this.getOptimalWallet(this.optimalWallet, true, false);
    }

    getFrecuency(event: any) {
        this.frecuencySelect = event;
    }
    //PRUEBAS PARA MODIFICAR EL ANCHO DE LA COLUMNAS

    startResizing(event: MouseEvent, column: HTMLElement) {
        // El mousedown llega desde el agarre dedicado (.resize-handle), así que la
        // intención de redimensionar es explícita. Evitamos que burbujee y que
        // seleccione texto durante el arrastre.
        event.preventDefault();
        event.stopPropagation();

        if (column.tagName === 'DIV') {
            const initialX = event.clientX;
            const initialWidth = column.offsetWidth;
            let dragStarted = false;

            const mouseMoveListener = (mouseEvent: MouseEvent) => {
                if (!dragStarted && Math.abs(mouseEvent.clientX - initialX) <= 3) return;
                dragStarted = true;
                const width = initialWidth + (mouseEvent.clientX - initialX);
                column.style.width = width + 'px';
            };

            const mouseUpListener = () => {
                document.removeEventListener('mousemove', mouseMoveListener);
                document.removeEventListener('mouseup', mouseUpListener);
            };

            document.addEventListener('mousemove', mouseMoveListener);
            document.addEventListener('mouseup', mouseUpListener);
        }
    }

    ngOnDestroy(): void {
        this.formdataSubcription.unsubscribe();
        this.ModeloSub.unsubscribe();
        this.SubTema.unsubscribe();
        this.carteraOptima.unsubscribe();
        this.subOptima.unsubscribe();
        this.subActivateInfomr.unsubscribe();
        this.subsimularGest.unsubscribe();
        this.subStatsFormdata.unsubscribe();
        this.subQueryParams?.unsubscribe();
        this.closeEstadisticasPanel();
    }

    expandirDiv() {
        if (this._ignorePanelHover) return;
        if (this.panelTimeout) { clearTimeout(this.panelTimeout); this.panelTimeout = null; }
        this.texto = "<<";
        this.mouseSobreDiv = true;
    }
    contraerDiv() {
        if (this._ignorePanelHover) return;
        this.panelTimeout = setTimeout(() => {
            this.texto = ">>";
            this.mouseSobreDiv = false;
        }, 200);
    }

    showTab(tab: any) {
        if (tab == 'cartera') {
            this.cartera = !this.cartera;
        } else if (tab == 'lista') {
            // Índice y conjunto de pestañas en el mismo ciclo: si el índice llega en otro tick,
            // Material ya movió la pestaña activa (sin emitir) y se producen dos saltos.
            this.listaCompaniaDiv = !this.listaCompaniaDiv;
            this.selectedTab = 0;
        } else {
            this.modeloDiv = !this.modeloDiv;
            // La columna se vuelve a abrir en Screener (tabModeloInicial), donde está el ancla.
            if (this.modeloDiv) {
                this.resetTabModelo(this.tabModeloInicial);
                setTimeout(() => this.openEstadisticasPanel());
            } else {
                this.closeEstadisticasPanel();
            }
        }
    }
    getDiaSemanalLiteral(ainput: Date): string {
        return ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'][ainput.getDay()];
    }

    onDiaSemanaChange(dia: { nombre: string; abrev: string; valor: number }, checked: boolean) {
        this.statsFormdata.diaSemanaSeleccionado = checked ? dia.valor : null;
        this.statsFormdata.diadesemana = checked;
        this.diasemanaliteral = checked ? dia.nombre : '';
    }

    openEstadisticasPanel() {
        if (!this.estadisticasPanelOpen || this.estadisticasOverlayRef || !this.estadisticasToggleAnchor) return;

        const positions: ConnectedPosition[] = [
            { originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'top', offsetX: 12 },
            { originX: 'start', originY: 'top', overlayX: 'end', overlayY: 'top', offsetX: -12 },
        ];
        const positionStrategy = this.overlay.position()
            .flexibleConnectedTo(this.estadisticasToggleAnchor)
            .withPositions(positions)
            .withPush(true);

        this.estadisticasOverlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            hasBackdrop: false,
        });

        this.estadisticasOverlayRef.attach(new TemplatePortal(this.estadisticasPanel, this.viewContainerRef));
    }

    closeEstadisticasPanel() {
        if (this.estadisticasOverlayRef) {
            this.estadisticasOverlayRef.dispose();
            this.estadisticasOverlayRef = null;
        }
    }

    /** true si la fecha "YYYY-MM-DD" cae en sábado o domingo (interpretada como fecha local). */
    private esFinDeSemana(fecha: string | null | undefined): boolean {
        if (!fecha) { return false; }
        const [y, m, d] = fecha.split('-').map(Number);
        if (!y || !m || !d) { return false; }
        const dia = new Date(y, m - 1, d).getDay(); // 0 = domingo, 6 = sábado
        return dia === 0 || dia === 6;
    }

    funcionaEstadisticas() {
        const tieneCondiciones = this.planificadorsv.condiciones.length > 0;
        const tieneDiaSemana = !!this.statsFormdata?.diadesemana && this.statsFormdata?.diaSemanaSeleccionado != null;
        if (!tieneCondiciones && !tieneDiaSemana) {
            this.toastr.error('Selecciona al menos una condición o un día de la semana para generar el análisis');
            return;
        }
        // El análisis filtra las señales por el día de la semana de la fecha inicial; si cae en
        // fin de semana no coincide con ninguna vela diaria y la corrida sale vacía.
        if (this.esFinDeSemana(this.Modelformdata.fechaInicio)) {
            this.toastr.error('La fecha inicial del análisis no puede caer en sábado ni domingo');
            return;
        }
        this.activatedEstadisticas = true;
        const jsonData = {
            list_conditions_entry: this.planificadorsv.interpretacionDataListEntry,
            list_conditions_exit: this.planificadorsv.interpretacionDataListExit,
            start: this.Modelformdata.fechaInicio ?? new Date('2018-01-01').toISOString().split('T')[0],
            end: new Date().toISOString().split('T')[0],
            idnectums: [],
            stopLoss: 20,
            bajista: false,
            periodo: 6,
            idmercado: this._rastreadorservice.idMercado.value,
            sectype: 'STK',
            ln: this.planificadorsv.condiciones,
            periodoModeloPeriodico: this.statsFormdata.periodoModeloPeriodico,
            nocondiciones: this.planificadorsv.noCondiciones,
            repeticionentradas: this.repeticionEntradas,
            diasEvaluar: this.statsFormdata.diasEvaluar,
            diasHabiles: this.statsFormdata.diashabiles,
            diadesemana: this.statsFormdata.diadesemana,
            diaSemanaSeleccionado: this.statsFormdata.diaSemanaSeleccionado,
            rangoPorcentualEvaluar: this.statsFormdata.rangoPorcentualEvaluar,
        };
        this.apisseservice.apiGetSse('rastreador/funcionAnalisis2?data=', true, encodeURIComponent(JSON.stringify(jsonData))).subscribe({
            next: (data: any) => {
                if (data.name === 'companias') this._rastreadorservice.updatecompaniaAnalisis(data.data);
                else if (data.name === 'lva') this._rastreadorservice.updatelistaVariacion(data.data);
                else if (data.name === 'arrayResultados') this._rastreadorservice.updateArrayResultados(data.data);
                else if (data.name === 'lvn') this._rastreadorservice.updatelistaVariacionNegativa(data.data);
                else if (data.name === 'idAnalisis') {
                    this._rastreadorservice.updateIdAnalisis(Number(data.data));
                    this.location.replaceState(`/models`, `id=${data.data}&modo=analisis`);
                }
                else if (data.name === 'err') this.toastr.error(data.data, 'Error');
                else if (data.name === 'info') this.toastr.success(data.data, 'Info');
                else if (data.name === 'fin') this.activatedEstadisticas = false;
            },
            error: (error: any) => {
                console.error('Error al generar estadísticas:', error);
                this.toastr.error('Error al generar estadísticas', 'Error');
                this.activatedEstadisticas = false;
            },
        });
    }

    guardarPonderador(simular: boolean): void {
        const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
        const dialogRef = this.dialog.open(DialogNameComponent, {
            width: '300px',
            panelClass: dialogClass,
            data: {
                name: nombreCarteraConSufijo(this.nombreSugerido, simular ? '-G' : ''),
                maxLength: MAX_NOMBRE_CARTERA,
                mensaje: simular ? undefined : 'Esta cartera estará disponible en Portfolio Labs'
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
            if (result) {
                this.optimalWallet.nombre = result;
                this.optimalWallet.stopLoss = this.Modelformdata.stoploss;

                this.optimalWallet.simulado = true;
                //console.log("Guardando optima en ponderador: ",this.optimalWallet.stopLoss);//lo estoy imprimiendo
                //console.log("Guardando optima en ponderador: ",this.optimalWallet);
                let auth_token = this.cookieService.get('auth_token');
                this.optimalWallet.idcarteraoptima = Number(this.idcarteraoptimaurl);
                /* aqui estmamos en guardar ponderador, alli vez el endpoint */
                this.apisseservice.apiPostNew('registrarcartera', this.optimalWallet, auth_token).subscribe(response => {
                    console.log('Response:', response);
                    if (response.idcartera > 0) {
                        this.toastr.success("Cartera registrada exitosamente");
                        if (simular) {
                            this._gestionsv.updategestOptimaWallet(response);
                            this._routerL.navigate(['/gestor']);
                        }
                    } else {
                        this.toastr.error(response.error);
                    }
                });
            }
        });

    }


    guardarInforme(): void {
        let carteraOptima = JSON.parse(JSON.stringify(this.optimalWallet));
        const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
        const dialogRef = this.dialog.open(DialogNameComponent, {
            width: '300px',
            panelClass: dialogClass,
            data: { name: nombreCarteraConSufijo(this.nombreSugerido, 'inf'), maxLength: MAX_NOMBRE_CARTERA, mensaje: 'Esta cartera estará disponible en Servicios -> Automatización Carteras' }
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
            if (result) {
                carteraOptima.nombre = result;
                carteraOptima.stopLoss = this.Modelformdata.stoploss;
                carteraOptima.profit = this.Modelformdata.profit;
                carteraOptima.simulado = true;
                // carteraOptima.idCarteras = array;
                carteraOptima.subCarteras = "informe";
                console.log("esta es la cartera a guardar: ", carteraOptima);
                console.log("idcarteraoptimaurl: ", this.idcarteraoptimaurl);
                carteraOptima.idcarteraoptima = Number(this.idcarteraoptimaurl);

                let auth_token = this.cookieService.get('auth_token');
                this.apisseservice.apiPostNew('registrarcartera', carteraOptima, auth_token).subscribe(response => {
                    console.log('Guardar Informe:', response);
                    console.log(response.error);
                    if (response.idcartera > 0) {
                        this.toastr.success("Cartera registrada exitosamente");
                    } else {
                        this.toastr.error(response.error);
                    }
                });
            }
        });

    }


    recalcularPonderador(array: any) {
        console.log("Evento desde modelo: ", array);
        this.optimalWallet.idCarteras = array;
        this.optimalWallet.idModelo = 0;
        this.optimalWallet.bajista = false;
        //  console.log("recalcula ponderador: ", this.optimalWallet);
        let todosCeros: boolean = this.optimalWallet.idCarteras.every(numero => numero === 0);
        if (todosCeros) {
            //  this.inicializarDataDiversificador();
        }
        console.log(this.optimalWallet);
        this.getOptimalWallet(this.optimalWallet, false, true);
    }

    formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    participacion(event: any, campo: any) {
        if (campo == 'participacion') {
            this.optimalWallet.participacion = event.checked;
            console.log("valor de optimalWallet.participacion ", this.optimalWallet.participacion);
        }
    }
    /*     changeSelect() {
            if(this.optimalWallet.tiporiesgo === 'LIMITADO'){
                this.optimalWallet.riesgo = 1000;
                this.optimalWallet.riesgoFijo = 0;
            }else if(this.optimalWallet.tiporiesgo === 'FIJO'){
                this.optimalWallet.riesgo = 0;
                this.optimalWallet.riesgoFijo = 1000;
            }
        } */

    guardarNotificacion(notificacion: Notificacion) {
        notificacion.estado = true;
        console.log(notificacion);
        this.notificacionService.guardarNotificacion(notificacion).subscribe({
            next: (value) => {
                //this.cd.markForCheck();
            },
            error: (err) => {
                console.log("Ocurrió un error actualizando la notificación");
            },
        });
    }
    toggleIndice() {
        this.planificadorsv.showIndice = !this.planificadorsv.showIndice;
    }

    toggleVolatilidad() {
        this.planificadorsv.showVolatilidad = !this.planificadorsv.showVolatilidad;
    }
    actualizarSlideStoploss(event: any) {
        this.stopLoss = event.checked;
        this.Modelformdata.stoplossCheck = event.checked;
    }
    actualizarSlideStoplossDinamico(event: any) {
        this.stopLossDinamico = event.checked;
        this.Modelformdata.stoplossDinamicCheck = event.checked;
    }
    actualizarSlideProfit(event: any) {
        this.proFit = event.checked;
        this.Modelformdata.profitCheck = event.checked;
    }
    onTipoEstrategiaChange(event: any) {
        const esBajista = event?.value === 'bajista';
        this.bajista = esBajista;
        this.Modelformdata.bajista = esBajista;
    }

    enviarAStrategyFactory(): void {
        if (!this.modeloMercado || !this.modeloMercado.idModelo) {
            this.toastr.error('Debe tener un modelo activo', 'Aviso');
            return;
        }

        // Verificar si hay gastos o comisiones activas
        const tieneGastosActivos = this.optimalWallet.chkcomisionbroker ||
            this.optimalWallet.chkgastogest ||
            this.optimalWallet.chkgastoprest;

        if (tieneGastosActivos) {
            const gastosActivados = [];
            if (this.optimalWallet.chkcomisionbroker) gastosActivados.push('Comisión Broker');
            if (this.optimalWallet.chkgastogest) gastosActivados.push('Gastos de Gestión');
            if (this.optimalWallet.chkgastoprest) gastosActivados.push('Gastos de Préstamo');

            const mensaje = `Tiene activados los siguientes gastos: ${gastosActivados.join(', ')}.

Strategy Factory también los aplica en su simulación: para que los datos coincidan, estos importes deben ser los mismos que los usados allí, no cero.

¿Desea continuar de todas formas?`;

            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                width: '400px',
                panelClass: this.theme,
                data: {
                    msj: mensaje
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.procedeEnviarAStrategyFactory();
                }
            });
        } else {
            this.procedeEnviarAStrategyFactory();
        }
    }

    private procedeEnviarAStrategyFactory(): void {
        const params: any = {
            idModelo: this.modeloMercado.idModelo.toString(),
            idMercado: (this.selectedIdMercado ?? '').toString(),
            periodo: (this.selectedFrecuency ?? this.Modelformdata.period ?? 6).toString(),
            fechaInicio: this.fechaInicial,
            capitalInicial: (this.optimalWallet.capitalinicial ?? 0).toString(),
            tipoCuenta: this.optimalWallet.tipocuenta,
            riesgo: (this.optimalWallet.riesgo ?? 0).toString(),
            tipoRiesgo: this.optimalWallet.tiporiesgo,
            stopLossActivo: (!!this.stopLoss).toString(),
            stopLossDinamicActivo: (!!this.stopLossDinamico).toString(),
            proFitActivo: (!!this.proFit).toString(),
            diasSalidaActivo: (!!this.diasSalida).toString(),
            salidaFinDiaActivo: (!!this.salidaFinDia).toString()
        };

        // Add optional parameters if they exist
        if (this.stopLoss && this.stopLossValue) {
            params.stopLoss = this.stopLossValue.toString();
        }
        if (this.proFit && this.proFitValue) {
            params.profit = this.proFitValue.toString();
        }
        if (this.diasSalida && this.diasSalidaValue) {
            params.diasSalida = this.diasSalidaValue.toString();
        }
        if (this.optimalWallet.margenRequeridoPor) {
            params.margenRequerido = this.optimalWallet.margenRequeridoPor.toString();
        }
        if (this.optimalWallet.controlMarginCall) {
            params.controlMarginCall = this.optimalWallet.controlMarginCall.toString();
        }
        if (this.optimalWallet.riesgomaximo) {
            params.riesgoMaximo = this.optimalWallet.riesgomaximo.toString();
        }
        if (this.Modelformdata.bajista !== undefined) {
            params.bajista = this.Modelformdata.bajista.toString();
        }
        // Comisión y gastos: mismos nombres que usa results-table en el sentido inverso, para que
        // Strategy Factory simule con los costes de /models y no con sus valores por defecto.
        if (this.optimalWallet.comisionbroker !== null && this.optimalWallet.comisionbroker !== undefined) {
            params.comisionbroker = this.optimalWallet.comisionbroker.toString();
        }
        if (this.optimalWallet.gastosGestionPor !== null && this.optimalWallet.gastosGestionPor !== undefined) {
            params.gastosGestionPor = this.optimalWallet.gastosGestionPor.toString();
        }
        if (this.optimalWallet.gastosPrestamoPor !== null && this.optimalWallet.gastosPrestamoPor !== undefined) {
            params.gastosPrestamoPor = this.optimalWallet.gastosPrestamoPor.toString();
        }
        params.chkcomisionbroker = (!!this.optimalWallet.chkcomisionbroker).toString();
        params.chkgastogest = (!!this.optimalWallet.chkgastogest).toString();
        params.chkgastoprest = (!!this.optimalWallet.chkgastoprest).toString();

        const queryString = new URLSearchParams(params).toString();
        window.open('/strategyfactory?' + queryString, '_blank');
        this.toastr.success('Abriendo Strategy Factory con el modelo seleccionado', 'Éxito');
    }
    actualizarSlideDiasSalida(event: any) {
        this.diasSalida = event.checked;
        this.Modelformdata.diasSalidaCheck = event.checked;
    }
    actualizarSlideSalidaFinDia(event: any) {
        this.salidaFinDia = event.checked;
        this.Modelformdata.salidaFinDiaCheck = event.checked;
    }
    buscarsectype(idmercado: string): string {
        let idm = Number(idmercado);
        //buscar en this.mercados por idmercado y retornar cfd
        const mercado = this.mercados.find(m => m.idmercado === idm);
        //console.log(mercado);
        return mercado ? mercado.sectype : '';

    }
    buscarmetaapi(idmercado: string): boolean {
        let idm = Number(idmercado);
        //buscar en this.mercados por idmercado y retornar cfd
        const mercado = this.mercados.find(m => m.idmercado === idm);
        //console.log(mercado);
        return mercado ? mercado.metaapi : false;

    }
    startEditing(item: string[]): void {
        console.log(item);
        this.editing = true;
    }
    modelIndicatorPeriod: IndicatorPeriod = {
        capFirst: 1000,
        capSuccesive: 100,
        period: 950,
        recoil: 0
    }
    finishEditing(item: string[]): void {
        this.editing = false;
        console.log('eicion terminada ');
        console.log(item);
        this.loading = true;
        this.activatedModelo = true;
        // Lo editado (item[0]) pasa a ser también el original (item[2]); si no, ln queda con el
        // texto viejo en item[2] y deja de coincidir con list_conditions_entry/exit.
        this.planificadorsv.condiciones.forEach(element => element[2] = element[0]);
        this.planificadorsv.sincronizarListasCondiciones();
        this.activatedModelo = false;
        console.log("final de edicion de condiciones");
        console.log(this.planificadorsv.interpretacionDataListEntry);
        this.loading = false;
        this.planificadorsv.loadingModel = false;

        console.log(this.planificadorsv.condiciones);


    }
    restoreWithOriginalWords(sentence: string, wordsToReplace: string[]): string {
        let words = sentence.split('"');
        words = words.map(word => {
            if (word.startsWith('indicador')) {
                const index = parseInt(word.replace('indicador_', '')) - 1;
                return wordsToReplace[index].replaceAll('_', ' ');
            }
            return word;
        });

        return words.join('"');
    }
    replaceWithIndicators(sentence: string, indicadoresIA: string[]): string {
        let words = sentence.split(' ');
        let indicatorIndex = 1;
        console.log(this.planificadorsv.indicatorsIaSinEspacios.length);
        words = words.map(word => {
            const index = this.planificadorsv.indicatorsIaSinEspacios.indexOf(word);
            if (index !== -1) { indicadoresIA.push(word) }
            return index !== -1 ? `indicador_${indicatorIndex++}` : word;
        });

        return words.join(' ');
    }
    public actualizarcapitalinicial() {
        console.log(this.totalactivos);
        if (this.totalactivos === undefined) {
            if (this.periodico) {
                this._sseservice.apiPostNew('mercado/contarActivosporMercado', { idmercado: this.Modelformdata.idMercado }, '').toPromise().then(
                    response => {
                        this.totalactivos = response.total;
                        if (this.totalactivos <= 10) {
                            this.actualizarcapitalinicial();
                        } else {
                            this.toastr.error("La lista de mercados seleccionada puede tener un máximo de 10 activos.");
                            this.Modelformdata.idMercado = this.idMercadoAnt;
                            this.selectedIdMercado = this.idMercadoAnt;
                            this.sincronizarIdMercado(Number(this.idMercadoAnt));
                        }
                    }
                ).catch(error => {
                    // this.loading = false;
                });
            }
        } else {
            let capitalInicialPrima = (this.optimalWallet.capitales[0] * this.totalactivos) + (this.optimalWallet.capitales[1] * this.totalactivos * this.Modelformdata.periodoModeloPeriodico);
            console.log(capitalInicialPrima);
            this.optimalWallet.capitalinicial = capitalInicialPrima;
        }
    }

    showCarteraHelp(): void {
        const helpData: HelpDialogData = {
            title: 'Ayuda - Cartera Óptima',
            items: [
                { term: 'Capital Inicial', description: 'El capital con el que se inicia la cartera.' },
                { term: 'Valor Liquidativo Neto', description: 'Valor actual de todos los activos de la cartera.' },
                { term: 'Efectivo', description: 'Dinero disponible para nuevas operaciones.' },
                { term: 'Tipo Cuenta', description: 'MARGEN (permite apalancamiento) o NOMINAL (sin apalancamiento).' },
                { term: 'Margen Requerido %', description: 'Porcentaje del capital requerido como garantía.' },
                { term: 'Control Margin Call %', description: 'Umbral de alerta para llamada de margen.' },
                { term: 'Riesgo Máximo %', description: 'Porcentaje máximo de capital que se puede arriesgar.' },
                { term: 'Tipo Riesgo', description: 'LIMITADO (según riesgo) o FIJO (cantidad fija).' },
                { term: 'Valor Riesgo', description: 'Valor monetario del riesgo por operación.' }
            ]
        };
        this.dialog.open(HelpDialogComponent, {
            width: '450px',
            data: helpData
        });
    }

    showRiesgoHelp(): void {
        const helpData: HelpDialogData = {
            title: 'Ayuda - Configuración Riesgo',
            items: [
                { term: 'Riesgo Máximo %', description: 'Porcentaje máximo del capital que se puede arriesgar en todas las operaciones abiertas.' },
                { term: 'Tipo Riesgo', description: 'LIMITADO: el tamaño de posición se calcula según el riesgo. FIJO: cantidad fija por operación.' },
                { term: 'Valor Riesgo', description: 'Cantidad monetaria máxima a arriesgar por cada operación individual.' },
                { term: 'Comisión 2/2', description: 'Comisión del broker aplicada tanto a la entrada como a la salida de cada operación.' },
                { term: 'Gastos Gestión', description: 'Porcentaje de gastos de gestión aplicados sobre el capital.' },
                { term: 'Gastos Préstamo %', description: 'Intereses por préstamo de acciones en operaciones en corto (bajistas).' },
                { term: 'Comprar/Vender Fracciones', description: 'Permite comprar fracciones de acciones en lugar de unidades completas.' }
            ]
        };
        this.dialog.open(HelpDialogComponent, {
            width: '450px',
            data: helpData
        });
    }

    showTabHelp(tab: string, event: Event): void {
        event.stopPropagation();
        const tabHelpData: { [key: string]: HelpDialogData } = {
            'gestion': {
                title: 'Ayuda - Gestión/Contabilidad',
                items: [
                    { term: 'Resumen', description: 'Vista general del estado de la cartera con métricas principales.' },
                    { term: 'Balance', description: 'Registro de movimientos de capital, depósitos y retiros.' },
                    { term: 'Comisiones', description: 'Detalle de comisiones pagadas al broker por operaciones.' }
                ]
            },
            'operaciones': {
                title: 'Ayuda - Operaciones',
                items: [
                    { term: 'Operaciones Abiertas', description: 'Posiciones actualmente en cartera con su rendimiento en tiempo real.' },
                    { term: 'Histórico', description: 'Registro de todas las operaciones cerradas con sus resultados.' },
                    { term: 'Filtros', description: 'Permite filtrar operaciones por fecha, tipo, activo, etc.' }
                ]
            },
            'valores': {
                title: 'Ayuda - Valores Liquidativos',
                items: [
                    { term: 'VL Diario', description: 'Valor liquidativo neto de la cartera calculado al cierre de cada día.' },
                    { term: 'Evolución', description: 'Gráfica de la evolución del valor de la cartera en el tiempo.' },
                    { term: 'Drawdown', description: 'Máxima caída desde el punto más alto de la curva de capital.' }
                ]
            },
            'rendimientos': {
                title: 'Ayuda - Rendimientos/Riesgos',
                items: [
                    { term: 'Rentabilidad', description: 'Porcentaje de ganancia o pérdida sobre el capital inicial.' },
                    { term: 'Sharpe Ratio', description: 'Mide el rendimiento ajustado al riesgo de la cartera.' },
                    { term: 'Volatilidad', description: 'Desviación estándar de los rendimientos, indica el riesgo.' },
                    { term: 'Max Drawdown', description: 'Máxima pérdida porcentual desde un máximo histórico.' }
                ]
            },
            'cartera': {
                title: 'Ayuda - Cartera',
                items: [
                    { term: 'Posiciones', description: 'Lista de activos en cartera con cantidad, precio y valor actual.' },
                    { term: 'Ponderación', description: 'Porcentaje que representa cada activo del total de la cartera.' },
                    { term: 'P&L', description: 'Ganancia o pérdida (Profit & Loss) de cada posición.' }
                ]
            },
            'earning': {
                title: 'Ayuda - Estudio Earning',
                items: [
                    { term: 'Estudio Earning', description: 'Analiza el comportamiento histórico del precio de la compañía seleccionada alrededor de sus fechas de earnings.' },
                    { term: 'Compañía', description: 'Selecciónala desde el panel "Lista Compañía".' }
                ]
            },
            'estadisticas': {
                title: 'Ayuda - Estadísticas',
                items: [
                    { term: 'Estadísticas', description: 'Ejecuta el análisis estadístico de las condiciones configuradas en "Crear Modelo" sobre la lista de compañías del panel "Compañías".' },
                    { term: 'Configuración', description: 'Ajusta día de la semana, días hábiles, rango % y días a evaluar desde el toggle "Estadísticas" del panel "Compañías".' }
                ]
            },
            'crearModelo': {
                title: 'Ayuda - Crear Modelo',
                items: [
                    { term: 'Nuevo Modelo', description: 'Permite crear un nuevo modelo de cartera con parámetros personalizados.' },
                    { term: 'Configuración', description: 'Define el nombre, capital inicial y parámetros del modelo.' },
                    { term: 'Mercado', description: 'Selecciona el mercado y activos disponibles para el modelo.' }
                ]
            },
            'buscador': {
                title: 'Ayuda - Buscador',
                items: [
                    { term: 'Búsqueda de Modelos', description: 'Encuentra modelos existentes por nombre o características.' },
                    { term: 'Filtros', description: 'Aplica filtros para refinar la búsqueda de modelos.' },
                    { term: 'Selección', description: 'Selecciona un modelo para ver sus detalles.' }
                ]
            },
            'screener': {
                title: 'Ayuda - Screener',
                items: [
                    { term: 'Qué hace', description: 'Busca qué compañías del mercado o lista seleccionada cumplen tus condiciones en una fecha concreta, sin construir un modelo.' },
                    { term: 'Mercado y fecha', description: 'Elige el mercado o lista a revisar y la fecha del estudio. Las condiciones son las mismas que en Crear Modelo.' },
                    { term: 'Buscar', description: 'Evalúa las condiciones sobre todos los activos y devuelve las compañías que las cumplen ese día.' },
                    { term: 'Crear Lista', description: 'Guarda las compañías encontradas como una lista con nombre. Después aparece en el desplegable de Mercados y se puede analizar como cualquier otro.' }
                ]
            },
            'graficaAnalisis': {
                title: 'Ayuda - Gráfica Análisis',
                items: [
                    { term: 'Gráfica Análisis', description: 'Muestra la gráfica de velas de la compañía activa en el análisis (pestaña Estadísticas) o del modelo seleccionado en Gestión/Contabilidad.' },
                    { term: 'Selección de activo', description: 'Se actualiza automáticamente al cambiar la compañía analizada, o al seleccionar una fila con modelo en la tabla de Gestión/Contabilidad.' }
                ]
            },
            'ia': {
                title: 'Ayuda - I.A.',
                items: [
                    { term: 'Asistente Inteligente', description: 'Utiliza inteligencia artificial para analizar y sugerir mejoras.' },
                    { term: 'Predicciones', description: 'Genera predicciones basadas en el análisis de datos históricos.' },
                    { term: 'Optimización', description: 'Sugiere optimizaciones para mejorar el rendimiento del modelo.' }
                ]
            }
        };
        const helpData = tabHelpData[tab];
        if (helpData) {
            this.dialog.open(HelpDialogComponent, {
                width: '450px',
                data: helpData
            });
        }
    }
}

export interface MercadosInterface {
    idmercado: number;
    iso: string;
    nombre: string;
    tipo: number;
    sectype: string;
    metaapi: boolean;
    activos?: number;
}

//#region General Interfaces
export interface SelectModel {
    description: string;
    value: string;
}

export interface SelectModelFrec {
    periodo: string;
    idperiodo: string;
}
//#endregion

export interface IndicatorTech {
    indicator1: string;
    bar1: number;
    indicator2: string;
    bar2: number;
    operator: string;
    value: string;
    period1?: TypeInicator;
    period2?: TypeInicator;
}

export interface TypeInicator {
    type: 'number' | 'text',
    value: string | number;
}

export interface IndicatorFundamental {
    type: string;
    indicator1: string;
    operator: string;
    indicator2: string;
    value: string;
    period?: string | number;
}

export interface IndicatorPeriod {
    capFirst: number;
    capSuccesive: number
    period: number;
    recoil: number;
}

